import React from 'react';
import '../styles/TermosDeUso.css'; // Importando o CSS específico para o componente
const TermosDeUso = () => {
  return (
    <div className="termos-de-uso-container">
      <h1 className="termos-de-uso-title">Termos de Uso</h1>
      <p className="termos-de-uso-intro">
        Ao utilizar nossos serviços, você concorda com os seguintes termos e condições. Leia atentamente para entender suas responsabilidades e direitos.
      </p>

      <div className="termos-de-uso-section">
        <h2>1. Uso Responsável</h2>
        <p>
          O uso do site deve ser feito de forma responsável e ética. Você concorda em não utilizar nossos serviços para:
        </p>
        <ul>
          <li>Violar leis ou regulamentos aplicáveis.</li>
          <li>Distribuir conteúdo prejudicial, ofensivo ou ilegal.</li>
          <li>Comprometer a segurança do site ou de outros usuários.</li>
        </ul>
      </div>

      <div className="termos-de-uso-section">
        <h2>2. Alterações nos Termos</h2>
        <p>
          Reservamo-nos o direito de alterar os termos a qualquer momento. As alterações serão publicadas nesta página e entrarão em vigor imediatamente.
        </p>
      </div>

      <div className="termos-de-uso-section">
        <h2>3. Limitação de Responsabilidade</h2>
        <p>
          Não nos responsabilizamos por danos diretos ou indiretos decorrentes do uso do site. O uso dos serviços é de sua inteira responsabilidade.
        </p>
      </div>

      <div className="termos-de-uso-section">
        <h2>4. Direitos Autorais</h2>
        <p>
          Todo o conteúdo do site, incluindo textos, imagens e logotipos, é protegido por direitos autorais. É proibida a reprodução sem autorização prévia.
        </p>
      </div>

      <div className="termos-de-uso-footer">
        <p>
          Para mais informações ou dúvidas sobre os Termos de Uso, entre em contato conosco pelo e-mail: <strong>cr.mesquita@terra.com.br</strong>.
        </p>
      </div>
    </div>
  );
};

export default TermosDeUso;